export const getSignatureConfigFilter = state => state.signatureConfig.filter

export const getSignatureConfigList = state => state.signatureConfig.signatureConfigList
